import { render, staticRenderFns } from "./ClusterMethod.vue?vue&type=template&id=862e94ae&"
import script from "./ClusterMethod.vue?vue&type=script&lang=js&"
export * from "./ClusterMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports